import { useEffect, useMemo, useState } from "react";

import { Box } from "@mantine/core";
import { useNavigate, useParams } from "react-router-dom";

import { CurationViewer } from "./builder/CurationViewer";
import { Curation, useMockServer } from "./builder/_mock";

export const PreviewCuration = () => {
  const navigate = useNavigate();
  const { curationId } = useParams();
  const { getCuration } = useMockServer();
  const [curation, setCuration] = useState<Curation | null>(null);

  // const { data, loading, error } = useBuilderGlobalSearchQuery({
  //   variables: {
  //     query: "JJ",
  //     limit: 10,
  //   },
  // });

  console.log("Curation ID", curationId, curation);
  // console.log("Global Search", data, loading, error);

  useEffect(() => {
    const loadCuration = async () => {
      try {
        if (curationId == null) {
          throw new Error("Curation ID is required");
        }
        const curation = await getCuration(curationId);
        setCuration(curation);
      } catch (error) {
        console.error("Error loading curation", error);
        // navigate("/404");
      }
    };

    loadCuration();
  }, [curation, curationId, getCuration, navigate]);

  const hydratedHTML = useMemo(() => {
    if (curation == null) {
      return "";
    }

    const css = curation.draft.css ?? "";
    const html = curation.draft.html ?? "";
    const final = `<div><style>${css}</style><div id="curation">${html}</div></div>`;
    const removedBody = final.replace(/<body[^>]*>/, "").replace("</body>", "");

    return removedBody;
  }, [curation]);

  if (curation == null) {
    return <div>Loading...</div>;
  }

  return (
    <Box>
      <CurationViewer html={hydratedHTML} />
    </Box>
  );
};
